import React from 'react';
import styled from 'styled-components';
import BaseButton from '../../../Atom/BaseButton';
import { formatPhoneString } from '@/shared/util/format/phoneNumberFormatUtil';

const DivWrapper = styled.div`
  width: 30%;
  max-height: 27rem;
  overflow-y: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: space-between;
  align-items: flex-start;
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 2rem;
  > div {
    height: 3rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0.6rem;
    :hover {
      background-color: ${(props) => props.theme.colors.gray300};
    }
    button {
      background-color: ${(props) => props.theme.colors.main};
      color: ${(props) => props.theme.colors.buttonText};
      padding: 0.2rem 0.4rem;
    }
  }
  @media screen and (max-width: 1080px) {
    width: 100%;
    height: auto;
    max-height: 18rem;
  }
  @media screen and (max-width: 768px) {
    font-size: 1.6rem;
  }
  @media screen and (max-width: 540px) {
    gap: 2rem;
    height: auto;
    margin: 1rem auto;
    overflow: unset;

    > div {
      height: auto;
    }
  }
`;

interface CallingNumberListProps {
  callback: string;
  phnId: string;
  regMethod: string;
  rsrvdId: string;
  usedDttm: string;
  verifiedYn: string;
  wrtDttm: string;
  originCallback: string;
}

const CallingNumberList = ({ allCallingNumberList, callbackListS, handleSubmit, handleDelete }: any) => {
  const lastNumber =
    allCallingNumberList?.filter(
      (el: CallingNumberListProps) =>
        el.verifiedYn === 'Y' && !el.callback.startsWith('015') && !el.callback.includes('(심사중)'),
    ).length <= 1;

  // TODO
  // 1. 010, 015 번호는 심사중이 아닌 상태의 번호 하나씩은 가지고 있어야함
  // 2. 010, 015가 2개 이상인 상태면 해당 라인의 번호는 삭제 버튼이 생성되고 삭제가 가능함
  // 현재 코드는 010은 적용되어있음, 다만 015는 당장 2개이상 발급받을 상황이없기 때문에 삭제 버튼이 없음

  return (
    <DivWrapper>
      {allCallingNumberList?.map((el: CallingNumberListProps) => {
        return (
          <div key={el.callback}>
            {formatPhoneString(el.callback)}
            {!el.callback.startsWith('015') && !lastNumber ? (
              <BaseButton
                type="button"
                width="auto"
                backgroundColor="transparent"
                marginLeft="1.2rem"
                fontSize="1.2rem"
                fontWeight="600"
                color="black"
                value={el.callback}
                onClick={(e) => handleDelete(e, el.originCallback)}
              >
                삭제
              </BaseButton>
            ) : (
              el.callback.includes('(심사중)') && (
                <BaseButton
                  type="button"
                  width="auto"
                  backgroundColor="transparent"
                  marginLeft="1.2rem"
                  fontSize="1.2rem"
                  fontWeight="600"
                  value={el.callback}
                  color="black"
                  onClick={(e) => handleDelete(e, el.originCallback)}
                >
                  삭제
                </BaseButton>
              )
            )}
          </div>
        );
      })}
    </DivWrapper>
  );
};

export default CallingNumberList;
